"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotTestPreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const component_2 = require("@front/layouts/default-layout/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const component_3 = require("./test-window/component");
const component_4 = require("./test-results/component");
const ApiCall_helper_1 = require("./helpers/ApiCall.helper");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const Websocket_helper_1 = require("./helpers/Websocket.helper");
component_3.BotTestWindow;
component_4.BotTestResults;
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="bot-test-preview-page">
    <div class="row">
      <div class="col-lg-12 col-12 pb-lg-5">
        <div class="mb-2" ?hidden="${x => x.compact}">
          <h1>${'botTest.preview.title'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${(x, c) => x.runTest.bind(x)()}" type="button"
              class="top-right-button mr-2 btn btn-success btn-lg" ?disabled="${x => x.isTestDisabled}">
              ${(0, fast_element_1.when)(x => x.isTestPendingOrRunning, (0, fast_element_1.html) `
                <app-loader block="true" width="15px" height="15px"></app-loader>
              `, (0, fast_element_1.html) `<i class="simple-icon-control-play mr-2"></i>`)}              
              ${'botTest.preview.run'.t()}
            </button>
            <button @click="${(x, c) => x.edit()}" type="button"
              class="top-right-button mr-2 btn btn-primary btn-lg" ?disabled="${x => !x.botTestId}">
              <i class="simple-icon-pencil mr-2"></i>
              ${'botTest.preview.edit'.t()}
            </button>
            <button @click="${(x, c) => x.back()}" type="button"
              class="top-right-button btn btn-outline-primary btn-lg">
              <i class="simple-icon-arrow-left mr-2"></i>
              ${'botTest.preview.back'.t()}
            </button>
          </div>
        </div>

        <div class="card card-body mb-5">
          
          <ul class="nav nav-tabs nav-fill mb-4" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link ${x => x.activeTab === 'data' ? 'active' : ''}" type="button"
                role="tab" @click="${x => x.switchToTab('data')}">
                <i class="simple-icon-notebook mr-2"></i>
                ${'botTest.preview.tabs.data'.t()}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link ${x => x.activeTab === 'results' ? 'active' : ''}" type="button" role="tab"
                @click="${x => x.switchToTab('results')}">
                <i class="simple-icon-chart mr-2"></i>
                ${'botTest.preview.tabs.test_results'.t()}
              </button>
            </li>
          </ul>

          
          <div class="tab-content">
            
            
            
            <div class="tab-pane ${x => x.activeTab === 'data' || !x.activeTab ? 'active show' : ''}" role="tabpanel">
              ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                <div class="text-center py-5">
                  <app-loader></app-loader>
                </div>
              `, (0, fast_element_1.html) `
                ${(0, fast_element_1.when)(x => x.botTest, (0, fast_element_1.html) `        
            
            <div class="row mb-4">
              
              <div class="col-lg-8 mb-3">
                <div class="card shadow-sm h-100">
                  <div class="card-body">
                    <h5 class="card-title text-secondary mb-4">
                      <i class="simple-icon-notebook mr-2"></i>
                      ${'botTest.preview.section.basic_info'.t()}
                    </h5>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="simple-icon-note"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'botTest.name'.t()}</small>
                            <strong>${x => { var _a; return ((_a = x.botTest) === null || _a === void 0 ? void 0 : _a.name) || 'botTest.preview.not_provided'.t(); }}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="simple-icon-calendar"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'botTest.testDate'.t()}</small>
                            <strong>${x => x.formattedTestDate}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="${x => x.statusIcon}"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'botTest.active'.t()}</small>
                            <strong class="${x => x.statusClass}">${x => x.statusLabel}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="simple-icon-people"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'botTest.preview.total_testers'.t()}</small>
                            <strong>${x => x.totalTesters}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="simple-icon-target"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'botTest.preview.total_targets'.t()}</small>
                            <strong>${x => x.totalTargets}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="simple-icon-user"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'botTest.preview.creator'.t()}</small>
                            <strong>${x => { var _a, _b; return ((_b = (_a = x.botTest) === null || _a === void 0 ? void 0 : _a.creator) === null || _b === void 0 ? void 0 : _b.name) || 'botTest.preview.unknown_creator'.t(); }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.botTest) === null || _a === void 0 ? void 0 : _a.description; }, (0, fast_element_1.html) `
                      <div class="row">
                        <div class="col-12">
                          <hr class="my-4">
                          <h6 class="text-muted mb-3">
                            <i class="simple-icon-text mr-2"></i>
                            ${'botTest.description'.t()}
                          </h6>
                          <div class="content-display">
                            <pre>${x => { var _a; return (_a = x.botTest) === null || _a === void 0 ? void 0 : _a.description; }}</pre>
                          </div>
                        </div>
                      </div>
                    `)}
                  </div>
                </div>
              </div>

              
              <div class="col-lg-4 mb-3">
                <div class="card shadow-sm h-100">
                  <div class="card-body">
                    <h5 class="card-title text-secondary mb-4">
                      <i class="simple-icon-chart mr-2"></i>
                      ${'botTest.preview.section.statistics'.t()}
                    </h5>
                    <div class="list-group list-group-flush">
                      <div class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <i class="simple-icon-people text-muted mr-2"></i>
                          ${'botTest.preview.testers_count'.t()}
                        </div>
                        <span class="badge bg-primary rounded-pill">${x => x.totalTesters}</span>
                      </div>
                      <div class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <i class="simple-icon-target text-muted mr-2"></i>
                          ${'botTest.preview.targets_count'.t()}
                        </div>
                        <span class="badge bg-secondary rounded-pill">${x => x.totalTargets}</span>
                      </div>
                      <div class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <i class="simple-icon-clock text-muted mr-2"></i>
                          ${'botTest.preview.created_date'.t()}
                        </div>
                        <small class="text-muted">${x => { var _a; return ((_a = x.botTest) === null || _a === void 0 ? void 0 : _a.created_at) ? new Date(x.botTest.created_at).toLocaleDateString() : '-'; }}</small>
                      </div>
                      <div class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <i class="simple-icon-refresh text-muted mr-2"></i>
                          ${'botTest.preview.updated_date'.t()}
                        </div>
                        <small class="text-muted">${x => { var _a; return ((_a = x.botTest) === null || _a === void 0 ? void 0 : _a.updated_at) ? new Date(x.botTest.updated_at).toLocaleDateString() : '-'; }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
            ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.botTest) === null || _a === void 0 ? void 0 : _a.testers) && x.botTest.testers.length > 0; }, (0, fast_element_1.html) `
              <div class="row mb-4">
                <div class="col-12">
                  <div class="card shadow-sm">
                    
                    <div class="card-header">
                      <h5 class="card-title text-secondary mb-3">
                        <i class="simple-icon-people mr-2"></i>
                        ${'botTest.preview.section.testers'.t()}
                      </h5>
                      <ul class="nav nav-tabs card-header-tabs" data-bs-toggle="tabs" role="tablist">
                        ${(0, fast_element_1.repeat)(x => { var _a; return ((_a = x.botTest) === null || _a === void 0 ? void 0 : _a.testers) || []; }, (0, fast_element_1.html) `
                          <li class="nav-item" role="presentation">
                            <div class="nav-link ${(x, c) => c.parent.activeTesterTab === String(x.id) ? 'active' : ''}"
                               @click="${(x, c) => c.parent.switchTesterTab(String(x.id) || '')}"
                               role="tab" style="cursor: pointer;">
                              <i class="simple-icon-chemistry mr-2"></i>
                              ${x => x.name}
                            </div>
                          </li>
                        `)}
                      </ul>
                    </div>

                    <div class="card-body">
                      
                      ${(0, fast_element_1.repeat)(x => { var _a; return ((_a = x.botTest) === null || _a === void 0 ? void 0 : _a.testers) || []; }, (0, fast_element_1.html) `
                        ${(0, fast_element_1.when)((x, c) => c.parent.activeTesterTab === String(x.id), (0, fast_element_1.html) `
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="mb-4">
                                <h6 class="text-muted mb-3">
                                  <i class="simple-icon-settings mr-2"></i>
                                  ${'botTest.preview.tester_configuration'.t()}
                                </h6>
                                <div class="row">
                                  <div class="col-md-6 mb-3">
                                    <small class="text-muted d-block">${'botTest.model'.t()}</small>
                                    <span class="badge bg-info">${(x, c) => c.parent.getModelDisplayName(x.model)}</span>
                                  </div>
                                  <div class="col-md-6 mb-3">
                                    <small class="text-muted d-block">${'botTest.temperature'.t()}</small>
                                    <span class="badge bg-warning">${x => x.temperature}</span>
                                  </div>
                                  <div class="col-md-6 mb-3">
                                    <small class="text-muted d-block">${'botTest.messagesCount'.t()}</small>
                                    <span class="badge bg-secondary">${x => x.messagesCount}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div class="col-lg-6">
                              ${(0, fast_element_1.when)(x => x.prompt, (0, fast_element_1.html) `
                                <div class="mb-4">
                                  <h6 class="text-muted mb-3">
                                    <i class="simple-icon-text mr-2"></i>
                                    ${'botTest.prompt'.t()}
                                  </h6>
                                  <div class="bg-light p-3 rounded" style="max-height: 200px; overflow-y: auto;">
                                    <pre class="mb-0" style="white-space: pre-wrap;">${x => x.prompt}</pre>
                                  </div>
                                </div>
                              `)}
                            </div>
                          </div>
                          
                          
                          <hr class="my-4">
                          <div class="row">
                            <div class="col-12">
                              <h6 class="text-muted mb-3">
                                <i class="simple-icon-target mr-2"></i>
                                ${'botTest.targets'.t()} (${x => { var _a; return ((_a = x.targets) === null || _a === void 0 ? void 0 : _a.length) || 0; }})
                              </h6>
                              ${(0, fast_element_1.when)(x => x.targets && x.targets.length > 0, (0, fast_element_1.html) `
                                <div class="row">
                                  ${(0, fast_element_1.repeat)(x => x.targets || [], (0, fast_element_1.html) `
                                    <div class="col-md-6 col-lg-4 mb-3">
                                      <div class="card border-light">
                                        <div class="card-body">
                                          <h6 class="card-title d-flex align-items-center">
                                            <i class="simple-icon-user mr-2 text-success"></i>
                                            ${x => { var _a; return ((_a = x.avatar) === null || _a === void 0 ? void 0 : _a.name) || 'botTest.preview.unknown_avatar'.t(); }}
                                          </h6>
                                          ${(0, fast_element_1.when)(x => x.overrideTesterPrompt, (0, fast_element_1.html) `
                                            <div class="mb-2">
                                              <span class="badge bg-warning text-dark">${'botTest.preview.prompt_overridden'.t()}</span>
                                            </div>
                                            ${(0, fast_element_1.when)(x => x.testerPromptOverride, (0, fast_element_1.html) `
                                              <div class="mb-2">
                                                <small class="text-muted d-block">${'botTest.testerPromptOverride'.t()}</small>
                                                <div class="small bg-light p-2 rounded" style="max-height: 80px; overflow-y: auto;">
                                                  ${x => x.testerPromptOverride}
                                                </div>
                                              </div>
                                            `)}
                                            ${(0, fast_element_1.when)(x => x.messagesCountOverride, (0, fast_element_1.html) `
                                              <div class="mb-2">
                                                <small class="text-muted d-block">${'botTest.messagesCount'.t()}</small>
                                                <span class="badge bg-secondary">${x => x.messagesCountOverride}</span>
                                              </div>
                                            `)}
                                          `)}
                                        </div>
                                      </div>
                                    </div>
                                  `)}
                                </div>
                              `, (0, fast_element_1.html) `
                                <div class="text-center py-3 text-muted">
                                  <i class="simple-icon-target" style="font-size: 2rem;"></i>
                                  <p class="mt-2 mb-0">${'botTest.preview.no_targets'.t()}</p>
                                </div>
                              `)}
                            </div>
                          </div>
                        `)}
                      `)}
                    </div>
                  </div>
                </div>
              </div>
            `)}

            ${(0, fast_element_1.when)(x => { var _a; return !((_a = x.botTest) === null || _a === void 0 ? void 0 : _a.testers) || x.botTest.testers.length === 0; }, (0, fast_element_1.html) `
              <div class="row mb-4">
                <div class="col-12">
                  <div class="card shadow-sm">
                    <div class="card-body text-center py-5">
                      <i class="simple-icon-people text-muted" style="font-size: 3rem;"></i>
                      <h5 class="text-muted mt-3">${'botTest.preview.no_testers'.t()}</h5>
                      <p class="text-muted">${'botTest.preview.no_testers_description'.t()}</p>
                    </div>
                  </div>
                </div>
              </div>
            `)}
                `, (0, fast_element_1.html) `
                  <div class="text-center py-5">
                    <i class="simple-icon-exclamation text-muted" style="font-size: 3rem;"></i>
                    <h3 class="text-muted mt-3">${'botTest.preview.not_found'.t()}</h3>
                    <p class="text-muted">${'botTest.preview.not_found_description'.t()}</p>
                    <button @click="${(x, c) => x.back()}" type="button" class="btn btn-primary">
                      <i class="simple-icon-arrow-left mr-2"></i>
                      ${'botTest.preview.back'.t()}
                    </button>
                  </div>
                `)}
              `)}
            </div>

            
            <div class="tab-pane ${x => x.activeTab === 'results' ? 'active show' : ''}" role="tabpanel">
              ${(0, fast_element_1.when)(x => x.activeTab === 'results', (0, fast_element_1.html) `
                <bot-test-results :botTest="${x => x.botTest}"></bot-test-results>
              `)}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    ${(0, fast_element_1.when)(x => x.testWindowOpen, (0, fast_element_1.html) `
        <rws-modal :closeModal="${x => x.closeTestWindow.bind(x)}"><bot-test-window :testers="${x => x.getActiveTesters()}"></bot-test-window></rws-modal>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.bot-test-preview-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
.bot-test-preview-page .icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bot-test-preview-page .icon-circle i {
  font-size: 1.2rem;
}
.bot-test-preview-page .content-display {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 1rem;
  background-color: #f8f9fa;
}
.bot-test-preview-page .content-display pre {
  margin: 0;
  font-family: inherit;
  font-size: 0.9rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.bot-test-preview-page .list-group-item {
  border-left: none;
  border-right: none;
}
.bot-test-preview-page .list-group-item:first-child {
  border-top: none;
}
.bot-test-preview-page .list-group-item:last-child {
  border-bottom: none;
}
.bot-test-preview-page .list-group-item.list-group-item-action:hover {
  background-color: #f8f9fa;
}
.bot-test-preview-page .cursor-pointer {
  cursor: pointer;
}
.bot-test-preview-page .card {
  transition: box-shadow 0.15s ease-in-out;
}
.bot-test-preview-page .card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.bot-test-preview-page .text-wrap {
  word-wrap: break-word;
  word-break: break-word;
}
.bot-test-preview-page .badge.bg-info {
  background-color: #0dcaf0 !important;
  color: white !important;
}
.bot-test-preview-page .badge.bg-warning {
  background-color: #ffc107 !important;
  color: #000;
}
.bot-test-preview-page .badge.bg-success {
  background-color: #198754 !important;
  color: white !important;
}
.bot-test-preview-page .badge.bg-secondary {
  background-color: #6c757d !important;
  color: white !important;
}
.bot-test-preview-page .badge.bg-primary {
  background-color: #0d6efd !important;
  color: white !important;
}
.bot-test-preview-page .nav-tabs .nav-item {
  max-width: 250px;
  flex: 0 0 auto;
}
.bot-test-preview-page .nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  transition: all 0.15s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bot-test-preview-page .nav-tabs .nav-link:hover {
  border-color: var(--bs-border-color-translucent);
}
.bot-test-preview-page .nav-tabs .nav-link.active {
  background-color: var(--bs-body-bg);
  border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
}
.bot-test-preview-page .btn.btn-success i {
  margin-right: 0.25rem;
}
.bot-test-preview-page .btn.btn-primary i {
  margin-right: 0.25rem;
}
.bot-test-preview-page .btn.btn-outline-primary i {
  margin-right: 0.25rem;
}`;
const shadowOptions = { "mode": "open" };
let BotTestPreview = class BotTestPreview extends client_1.RWSViewComponent {
    constructor(popupService, wsService) {
        super();
        this.popupService = popupService;
        this.wsService = wsService;
        this.compact = false;
        this.loading = false;
        this.botTestId = null;
        this.botTest = null;
        this.activeTab = 'data';
        this.activeTesterTab = null;
        this.testWindowOpen = false;
        this.loadBotTest = ApiCall_helper_1.ApiCallHelper.loadBotTest.bind(this);
        // Force activeTab to data immediately on construction
        this.activeTab = 'data';
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    get formattedTestDate() {
        var _a;
        if (!((_a = this.botTest) === null || _a === void 0 ? void 0 : _a.testDate))
            return 'botTest.preview.not_provided'.t();
        return new Date(this.botTest.testDate).toLocaleDateString();
    }
    get statusLabel() {
        if (!this.botTest)
            return 'botTest.preview.status.unknown'.t();
        // Check if we have test execution status
        if (this.botTest.status) {
            const validStatuses = [backendImport_1.BotTestStatus.PENDING, backendImport_1.BotTestStatus.RUNNING, backendImport_1.BotTestStatus.COMPLETED, backendImport_1.BotTestStatus.FAILED, backendImport_1.BotTestStatus.STANDBY];
            if (validStatuses.includes(this.botTest.status)) {
                switch (this.botTest.status) {
                    case backendImport_1.BotTestStatus.STANDBY: return 'botTest.preview.status.standby'.t();
                    case backendImport_1.BotTestStatus.PENDING: return 'botTest.preview.status.pending'.t();
                    case backendImport_1.BotTestStatus.RUNNING: return 'botTest.preview.status.running'.t();
                    case backendImport_1.BotTestStatus.COMPLETED: return 'botTest.preview.status.completed'.t();
                    case backendImport_1.BotTestStatus.FAILED: return 'botTest.preview.status.failed'.t();
                }
            }
        }
        // Fallback to active/inactive status
        return this.botTest.active ? 'botTest.preview.status.active'.t() : 'botTest.preview.status.inactive'.t();
    }
    get statusIcon() {
        if (!this.botTest)
            return 'simple-icon-question';
        // Check if we have test execution status
        if (this.botTest.status) {
            const validStatuses = [backendImport_1.BotTestStatus.PENDING, backendImport_1.BotTestStatus.RUNNING, backendImport_1.BotTestStatus.COMPLETED, backendImport_1.BotTestStatus.FAILED, backendImport_1.BotTestStatus.STANDBY];
            if (validStatuses.includes(this.botTest.status)) {
                switch (this.botTest.status) {
                    case backendImport_1.BotTestStatus.STANDBY: return 'simple-icon-hourglass';
                    case backendImport_1.BotTestStatus.PENDING: return 'simple-icon-clock';
                    case backendImport_1.BotTestStatus.RUNNING: return 'simple-icon-reload';
                    case backendImport_1.BotTestStatus.COMPLETED: return 'simple-icon-check';
                    case backendImport_1.BotTestStatus.FAILED: return 'simple-icon-close';
                }
            }
        }
        // Fallback to active/inactive status
        return this.botTest.active ? 'simple-icon-check' : 'simple-icon-close';
    }
    get statusClass() {
        if (!this.botTest)
            return 'text-muted';
        // Check if we have test execution status
        if (this.botTest.status) {
            const validStatuses = [backendImport_1.BotTestStatus.PENDING, backendImport_1.BotTestStatus.RUNNING, backendImport_1.BotTestStatus.COMPLETED, backendImport_1.BotTestStatus.FAILED, backendImport_1.BotTestStatus.STANDBY];
            if (validStatuses.includes(this.botTest.status)) {
                switch (this.botTest.status) {
                    case backendImport_1.BotTestStatus.STANDBY: return 'text-secondary';
                    case backendImport_1.BotTestStatus.PENDING:
                    case backendImport_1.BotTestStatus.RUNNING: return 'text-info';
                    case backendImport_1.BotTestStatus.COMPLETED: return 'text-success';
                    case backendImport_1.BotTestStatus.FAILED: return 'text-danger';
                    default: return 'text-muted';
                }
            }
        }
        // Fallback to active/inactive status
        return this.botTest.active ? 'text-success' : 'text-danger';
    }
    get totalTesters() {
        var _a, _b;
        return ((_b = (_a = this.botTest) === null || _a === void 0 ? void 0 : _a.testers) === null || _b === void 0 ? void 0 : _b.length) || 0;
    }
    get totalTargets() {
        var _a, _b;
        let count = 0;
        (_b = (_a = this.botTest) === null || _a === void 0 ? void 0 : _a.testers) === null || _b === void 0 ? void 0 : _b.forEach(tester => {
            var _a;
            count += ((_a = tester.targets) === null || _a === void 0 ? void 0 : _a.length) || 0;
        });
        return count;
    }
    get hasTestResults() {
        var _a, _b;
        let hasResults = false;
        (_b = (_a = this.botTest) === null || _a === void 0 ? void 0 : _a.testers) === null || _b === void 0 ? void 0 : _b.forEach(tester => {
            var _a;
            (_a = tester.targets) === null || _a === void 0 ? void 0 : _a.forEach(target => {
                if (target.testResults && target.testResults.length > 0) {
                    hasResults = true;
                }
            });
        });
        return hasResults;
    }
    get isTestPendingOrRunning() {
        var _a, _b;
        return ((_a = this.botTest) === null || _a === void 0 ? void 0 : _a.status) === backendImport_1.BotTestStatus.PENDING || ((_b = this.botTest) === null || _b === void 0 ? void 0 : _b.status) === backendImport_1.BotTestStatus.RUNNING;
    }
    get isTestDisabled() {
        console.log(`Checking if test is disabled. botTestId: ${this.botTestId}, loading: ${this.loading}, isTestPendingOrRunning: ${this.isTestPendingOrRunning}`);
        return !this.botTestId || this.loading || this.isTestPendingOrRunning;
    }
    async connectedCallback() {
        var _a, _b;
        super.connectedCallback();
        // Explicitly set Data tab as active by default
        this.activeTab = 'data';
        // Force a render update to ensure template shows data tab
        this.$fastController.notify('activeTab');
        if (!this.botTestId && ((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id)) {
            this.botTestId = Number(this.routeParams.id);
        }
        if (this.botTestId) {
            await this.loadBotTest();
            // Set the first tester as active by default
            if (((_b = this.botTest) === null || _b === void 0 ? void 0 : _b.testers) && this.botTest.testers.length > 0 && !this.activeTesterTab) {
                this.activeTesterTab = String(this.botTest.testers[0].id);
            }
            // Ensure activeTab stays as data after loading
            if (this.activeTab !== 'data' && this.activeTab !== 'results') {
                this.activeTab = 'data';
            }
            this.on('close-test-window', () => {
                this.testWindowOpen = false;
                this.switchToTab('results');
            });
            Websocket_helper_1.WebsocketHelper.listenForWS.bind(this)();
            Websocket_helper_1.WebsocketHelper.listenForMessagesInWS.bind(this)();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.unsubscribeWS) {
            this.unsubscribeWS();
            this.unsubscribeWS = null;
        }
        if (this.unsubscribeMsgWS) {
            this.unsubscribeMsgWS();
            this.unsubscribeMsgWS = null;
        }
    }
    async runTest() {
        const confirmed = await this.popupService.confirm('botTest.preview.run_confirmation'.t());
        if (!confirmed)
            return;
        this.testWindowOpen = true;
    }
    getModelDisplayName(model) {
        var _a, _b;
        if (!model)
            return 'botTest.preview.no_model'.t();
        return ((_a = model.model) === null || _a === void 0 ? void 0 : _a.label) || ((_b = model.model) === null || _b === void 0 ? void 0 : _b.value) || 'botTest.preview.unknown_model'.t();
    }
    switchTesterTab(testerId) {
        this.activeTesterTab = testerId;
    }
    back() {
        component_1.SiteMenu.goto.bind(this)('/bot-test/list');
    }
    edit() {
        if (this.botTestId) {
            component_1.SiteMenu.goto.bind(this)(`/bot-test/edit/${this.botTestId}`);
        }
    }
    closeTestWindow() {
        this.testWindowOpen = false;
    }
    getActiveTesters() {
        if (!this.botTest)
            return [];
        return this.botTest.testers;
    }
    switchToTab(tab) {
        this.activeTab = tab;
    }
};
exports.BotTestPreview = BotTestPreview;
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], BotTestPreview.prototype, "compact", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], BotTestPreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], BotTestPreview.prototype, "botTestId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IBotTest !== "undefined" && backendImport_1.IBotTest) === "function" ? _c : Object)
], BotTestPreview.prototype, "botTest", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], BotTestPreview.prototype, "activeTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], BotTestPreview.prototype, "activeTesterTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], BotTestPreview.prototype, "testWindowOpen", void 0);
exports.BotTestPreview = BotTestPreview = __decorate([
    (0, client_1.RWSView)('bot-test-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(1, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _b : Object])
], BotTestPreview);
BotTestPreview.defineComponent();
